<template>
  <li
    class="group relative"
    :class="[
      adder && 'p-2 cursor-pointer border border-gray-200 text-gray-600 hover:bg-gray-50 duration-200 border-dashed rounded-lg flex items-center space-x-2',
      !adder && 'p-2 cursor-pointer rounded-lg hover:bg-gray-100 border border-transparent font-medium',
      selected && 'text-blue-600 !bg-blue-50 hover:!border-transparent-200 font-bold',

      focused && !error && '!bg-blue-50 text-blue-600',
      focused && !error && adder && '!border-blue-600',
      error && '!border-red-600 !bg-red-50 text-red-600',
   ]"

    @click.stop="itemClick"
    v-click-outside="stopEditing"
  >
    <svg v-if="adder" xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 shrink-0" viewBox="0 0 20 20" fill="currentColor">
      <path fill-rule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clip-rule="evenodd" />
    </svg>
    <span
      v-if="!editing"
      class="ske"
      :class="!adder && '-translate-y-[2px] inline-block'"
    >
      {{ adder ? 'New page' : newName }}
    </span>
    <input
      v-else
      v-model.trim="newName"
      class="grow w-full outline-none bg-transparent placeholder-gray-300 font-medium"
      :class="!adder && '-translate-y-[2px]'"
      placeholder="New page"

      ref="input"

      @focus="focused = true"
      @blur="focused = false"
    >

    <PageConfiguration
      v-if="!adder && !loading"
      :name="newName"
      :uid="uid"

      class="top-1/2 -translate-y-1/2 absolute right-0"
      @set-new-name="val => newName = val"
      @save="save"
    >
      <svg
        class="-mt-1 -translate-y-[1px] h-4 w-4 cursor-pointer opacity-0 group-hover:opacity-100 text-gray-600 hover:text-blue-600 duration-200 mr-8 inline-block"

        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
      >
        <path fill-rule="evenodd" d="M11.828 2.25c-.916 0-1.699.663-1.85 1.567l-.091.549a.798.798 0 01-.517.608 7.45 7.45 0 00-.478.198.798.798 0 01-.796-.064l-.453-.324a1.875 1.875 0 00-2.416.2l-.243.243a1.875 1.875 0 00-.2 2.416l.324.453a.798.798 0 01.064.796 7.448 7.448 0 00-.198.478.798.798 0 01-.608.517l-.55.092a1.875 1.875 0 00-1.566 1.849v.344c0 .916.663 1.699 1.567 1.85l.549.091c.281.047.508.25.608.517.06.162.127.321.198.478a.798.798 0 01-.064.796l-.324.453a1.875 1.875 0 00.2 2.416l.243.243c.648.648 1.67.733 2.416.2l.453-.324a.798.798 0 01.796-.064c.157.071.316.137.478.198.267.1.47.327.517.608l.092.55c.15.903.932 1.566 1.849 1.566h.344c.916 0 1.699-.663 1.85-1.567l.091-.549a.798.798 0 01.517-.608 7.52 7.52 0 00.478-.198.798.798 0 01.796.064l.453.324a1.875 1.875 0 002.416-.2l.243-.243c.648-.648.733-1.67.2-2.416l-.324-.453a.798.798 0 01-.064-.796c.071-.157.137-.316.198-.478.1-.267.327-.47.608-.517l.55-.091a1.875 1.875 0 001.566-1.85v-.344c0-.916-.663-1.699-1.567-1.85l-.549-.091a.798.798 0 01-.608-.517 7.507 7.507 0 00-.198-.478.798.798 0 01.064-.796l.324-.453a1.875 1.875 0 00-.2-2.416l-.243-.243a1.875 1.875 0 00-2.416-.2l-.453.324a.798.798 0 01-.796.064 7.462 7.462 0 00-.478-.198.798.798 0 01-.517-.608l-.091-.55a1.875 1.875 0 00-1.85-1.566h-.344zM12 15.75a3.75 3.75 0 100-7.5 3.75 3.75 0 000 7.5z" clip-rule="evenodd" />
      </svg>
    </PageConfiguration>
    <svg
      v-if="!adder && !loading"
      class="h-4 w-4 cursor-pointer opacity-0 group-hover:opacity-100 text-gray-600 hover:text-red-600 duration-200 absolute right-0 mr-2 top-1/2 -translate-y-1/2 inline-block"
      @click.stop="deleteItem"

      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd" />
    </svg>
  </li>
</template>

<script>

import PageConfiguration from "@/components/SideEditor/Pages/PageConfiguration"

export default {
  components: {
    PageConfiguration,
  },
  props: ['name', 'adder', 'selected', 'loading', 'uid'],
  data() {
    return {
      error: null,
      editing: false,
      focused: false,
      newName: this.name || "",
    }
  },
  methods: {
    save() {
      if (!this.newName) return this.error = "Page name cannot be empty!"
      this.$emit("save", this.newName)
      this.stopEditing()
    },
    deleteItem() {
      this.$emit('delete')
    },

    keydown({ key }) {
      switch (key) {
        case "Escape": return this.stopEditing()
        case "Enter": return this.save()
      }
    },
    addListener() {
      window.addEventListener("keydown", this.keydown, {passive: true})
    },
    removeListener() {
      window.removeEventListener("keydown", this.keydown)
    },

    itemClick() {
      if (this.adder) this.startEditing()
      else this.$emit('select')
    },
    startEditing() {
      this.editing = true
      this.$nextTick(() => this.$refs.input.focus())
    },
    stopEditing() {
      this.editing = false
      this.newName = this.name || ""
      this.error = null
    },
  },
  watch: {
    error(message) {
      message && this.$store.dispatch("toast/error", { message })
    },
    editing(editing) {
      if (editing) this.addListener()
      else this.removeListener()
    },
    newName() {
      this.error = null
    },
  },
}

</script>
